
import AppBrowse from "@/components/browse/Browse.vue";
import { BrowseService } from "@/services/browse-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import Vue from "vue";
import { ProspectService } from "../../services/prospect-service";
import { UserConfigService } from "../../services/user-config-service";
import { checkHasModule } from "../../router";
import { MODULE } from "../../config/modules";
import { View } from "@/models/view";
import { FetchedTotal } from "@/utils/views/fetched-total";
import { BrowseState } from "@/utils/browse/browse-state";
import { LedgerAccount } from "@/models/ledger-account";
import { BrowseID } from "@/models/browse";
import { DossierConfigService, LedgerAccountService } from "@/services";
import AppCreate from "./LedgerAccountBrowseCreateCard.vue";
import AppEdit from "./LedgerAccountBrowseEditCard.vue";
import AppUploadCsvModal from "./LedgerAccountsUploadCsv.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as LedgerAccount[],
			browseState: null as null | BrowseState,
			createModalOpen: false,
			toEditAccount: null as null | LedgerAccount,
			uploadModalOpen: false
		};
	},
	computed: {
		dataSource(): IBrowseDataSource<LedgerAccount> {
			let elem = this;
			return {
				getFullElement: (el:LedgerAccount)=>LedgerAccountService.getLedgerAccount(el.Code),
				getSettings: () => BrowseService.getBrowse(BrowseID.LEDGER_ACCOUNTS),
				getElements: LedgerAccountService.getLedgerAccounts.bind(LedgerAccountService),
				getTotals(view:View):Promise<FetchedTotal[]>{
					return ProspectService.getTotals(view);
				},
				async edit(ledgerAccount: LedgerAccount) {
					elem.toEditAccount = await LedgerAccountService.getLedgerAccount(ledgerAccount.Code);
				},
				async delete(accounts:LedgerAccount[]) {
					let lastRefresh = new Date();
					for (let account of accounts){
						if (new Date().getTime() - lastRefresh.getTime() > 2000){
							elem.updateView();
							lastRefresh = new Date();
						}
						await LedgerAccountService.deleteLedgerAccount(account);
					}
					elem.updateView();
					return true;
				},
				addRoute: "/bookkeeping/ledger-accounts/new",
				browseName: "LedgerAccounts",
				modelName: "LedgerAccount",
				browsePermissions: ()=> UserConfigService.getPermissionSettings().PurchasePermissions,
				compareFunc: (a:LedgerAccount, b:LedgerAccount):boolean =>{
					return a.Code == b.Code;
				},
				extraFieldSettings: {
					getExtraFields: LedgerAccountService.getExtraFields.bind(LedgerAccountService),
					nameSettings: DossierConfigService.getExtraFieldNamesConfigs().LedgerAccountNames,
					batchEdit: LedgerAccountService.batchEditExtraField.bind(LedgerAccountService),
					edit: (LedgerAccountService.updateExtraFields as any).bind(LedgerAccountService),
					areFetched: (item:LedgerAccount):boolean => (item.ExtraFields && item.ExtraFields.Code == item.Code) || false
				}
			};
		},
		canWrite():boolean {
			return UserConfigService.hasCurrentUserPermission((p)=>p.ProspectPermissions.hasWritePermissions());
		},
		buttonBarItems():ISelectItem<Function>[]{
			return [
				{
					text: this.$ct("upload-csv"),
					icon: "upload",
					value: ()=> this.uploadModalOpen = true
				}
			];
		}
	},
	watch: {
		"$route.path": {
			immediate: true,
			handler(){
				if (this.$route.path.split("/").length == 3){
					ToolbarService.title = this.$ct("ledger-accounts");
				}
				this.createModalOpen = this.$route.path.endsWith("/new");
			}
		}
	},
	methods: {
		async updateView(){
			if (!this.browseState) return;
			await this.browseState.fetch();
		},
		closeCreateModal(){
			this.$router.push("/bookkeeping/ledger-accounts");
		},
		refresh(){
			if (!this.browseState) return;
			this.browseState.fetch();
		}
	},
	created(){
		if (!checkHasModule(MODULE.BOEKHOUDLIJSTEN, this.$router)){
			throw new Error("MISSING MODULE");
		}
	},
	components: {
		AppBrowse,
		AppCreate,
		AppEdit,
		AppUploadCsvModal
	},
	i18nEx: {
		componentPrefix: "components.ledger-accounts"
	},
});
